<template>
  <v-card class="ncd rounded-lg">
    <div class="ncd__head">
      <div>
        <div class="ncd__eyebrow">Agenda</div>
        <h2 class="ncd__title">{{ $t("contact.new.title") }}</h2>
      </div>
      <button type="button" class="ncd__close" @click="$emit('close')" aria-label="Cerrar">
        <hero-icon :icon="XMarkIcon" :size="18" />
      </button>
    </div>

    <div class="ncd__divider"></div>

    <div class="ncd__body">
      <div v-if="list" class="ncd__pick">
        <div class="ncd__row">
          <v-autocomplete
            :items="contacts"
            item-text="profile.name"
            item-value="id"
            v-model="selected"
            label="Seleccionar contacto existente…"
            outlined
            dense
            hide-details
            class="ncd__field"
          ></v-autocomplete>

          <v-btn
            depressed
            color="primary"
            class="rounded-lg ncd__pickbtn"
            :disabled="!selected"
            @click="manualCreate"
          >
            <hero-icon :icon="CheckIcon" :size="18" />
          </v-btn>
        </div>

        <div class="ncd__or"><span>O cree un contacto nuevo</span></div>
      </div>

      <v-form lazy-validation ref="form" v-model="valid" class="ncd__form">
        <v-text-field
          outlined
          dense
          label="Nombre"
          :rules="[v => !!v || $t('required_fields_hint')]"
          v-model="contact.name"
          class="ncd__field"
        ></v-text-field>

        <vuetify-google-autocomplete
          outlined
          dense
          id="map"
          :label="$t('contact.new.fields.address')"
          v-model="contact.address"
          class="ncd__field"
        ></vuetify-google-autocomplete>

        <v-text-field
          outlined
          dense
          :label="$t('contact.new.fields.email')"
          v-model="contact.email"
          class="ncd__field"
        ></v-text-field>

        <v-text-field
          outlined
          dense
          type="number"
          :label="$t('contact.new.fields.phone')"
          v-model="contact.phone"
          class="ncd__field"
        ></v-text-field>
      </v-form>
    </div>

    <div class="ncd__actions">
      <v-btn text color="primary" class="rounded-lg" @click.stop="$emit('close')">
        {{ $t("action.cancel") }}
      </v-btn>
      <v-btn
        color="accent"
        depressed
        class="rounded-lg"
        :loading="loading"
        :disabled="loading"
        @click.stop="create"
      >
        {{ $t("action.create") }}
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import { CreateContact } from "@/graphql/mutations/directory";
import { Contacts } from "@/graphql/queries/directory";
import HeroIcon from "@/components/shared/HeroIcon";
import XMarkIcon from "heroicons/24/outline/x-mark.svg";
import CheckIcon from "heroicons/24/outline/check.svg";

export default {
  components: { HeroIcon },

  data() {
    return {
      XMarkIcon,
      CheckIcon,
      valid: true,
      contacts: [],
      selected: null,
      loading: false,
      contact: {
        name: "",
        address: "",
        email: "",
        phone: "",
        dni: ""
      }
    };
  },

  props: {
    data: {
      required: false,
      type: Object
    },
    list: {
      required: false,
      type: Boolean,
      default: false
    }
  },

  created() {
    if (this.data) {
      this.contact.name = this.data.name;
      this.contact.email = this.data.email;
      this.contact.phone = this.data.phone;
    }

    if (this.list) {
      this.fetchOwners();
    }
  },

  methods: {
    create() {
      if (this.valid) this.valid = this.$refs.form.validate();
      this.loading = true;

      if (this.valid) {
        this.$apollo
          .mutate({
            mutation: CreateContact,
            variables: {
              input: {
                contactAttributes: this.contact
              }
            }
          })
          .then(res => {
            this.loading = false;
            this.$emit("created", res.data.createContact.user);
          });
      }
    },

    manualCreate() {
      this.$emit("created", { id: this.selected });
    },

    fetchOwners() {
      this.$apollo
        .query({
          query: Contacts,
          variables: {
            noPaginate: true
          },
          fetchPolicy: "cache-first"
        })
        .then(res => {
          this.contacts = res.data.contacts.contacts;
        });
    }
  }
};
</script>

<style scoped>
.ncd { background: #fff; border: 1px solid #ece7de; }

.ncd__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 22px 24px 16px;
}
.ncd__eyebrow {
  font-size: 10.5px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #a39a8c;
  font-weight: 600;
}
.ncd__title {
  font-size: 19px;
  font-weight: 700;
  color: #1a1814;
  margin: 4px 0 0;
  line-height: 1.2;
}
.ncd__close {
  flex: none;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: none;
  border: none;
  cursor: pointer;
  color: #a39a8c;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s ease, color 0.15s ease;
}
.ncd__close:hover { background: #f1ece3; color: #1a1814; }

.ncd__divider { height: 1px; background: #ece7de; }

.ncd__body { padding: 20px 24px 4px; }
.ncd__row { display: flex; align-items: center; gap: 10px; }
.ncd__row .ncd__field { flex: 1; }
.ncd__pickbtn { min-width: 44px !important; height: 40px !important; }
.ncd__or {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #a39a8c;
  font-size: 12px;
  margin: 14px 0;
}
.ncd__or::before,
.ncd__or::after { content: ''; flex: 1; height: 1px; background: #ece7de; }

.ncd__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 24px 18px;
}

.ncd__field >>> fieldset { border-radius: 10px; }
.ncd__pickbtn .hero-icon { color: #fff; }
</style>
